export interface BudgetOption {
    label: string;
    value: string;
    amount: string;
}

export const BUDGET_RANGES: readonly BudgetOption[] = [
    { label: '50k - 100k', value: 'p_50k__100k', amount: '50000' },
    { label: '100k - 250k', value: 'p_100k__250k', amount: '100000' },
    { label: '250k - 500k', value: 'p_250k__500k', amount: '250000' },
    { label: '500k - 1M', value: 'p_500k__1m', amount: '500000' },
    { label: '1M+', value: 'p_1m', amount: '1000000' },
    { label: 'Not sure yet', value: 'not_sure_yet', amount: '0' },
] as const;

export const BUDGET_RANGE_TO_AMOUNT: Record<string, string> = BUDGET_RANGES.reduce((acc, option) => {
    acc[option.value] = option.amount;
    return acc;
}, {} as Record<string, string>);
